import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { newKey } from '../../../tools/mockData'
import { updateEndorsementKeyAsync } from '../../api/endorsementKeyApi'
import { GenericKeyResponseDto } from '../../api/kmsapiclient'
import { KeyInfo } from '../../components/common/types'
import { UPDATE_KEYS_PERMISSION } from '../../redux/actions/actionTypes'
import {
  apiCallError,
  beginApiCall,
  endApiCall,
} from '../../redux/actions/apiStatusActions'
import { updateEndorsementKeySuccess } from '../../redux/actions/endorsementKeysActions'
import { store, useAppDispatch } from '../../redux/configureStore'
import { EndorsementKeys } from '../../redux/reducers/initialState'
import KeyForm from '../common/KeyForm'
import { usePermissions } from '../common/permission/usePermissions'
import { getKeyBySlug } from '../common/utils'

type EditEndorsementKeyPageProps = {
  match: any
  history: any
}

const EditEndorsementKeyPage = ({
  match,
  history,
}: EditEndorsementKeyPageProps) => {
  const { checkPermissions } = usePermissions()
  const endorsementKeys = useSelector((state: EndorsementKeys) =>
    Object.entries(state.endorsementKeys).length === 0 ||
    Object.entries(state.endorsementKeys.keys).length === 0
      ? []
      : state.endorsementKeys.keys,
  )

  if (endorsementKeys.length === 0) {
    history.push('/')
  }

  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)
  const [entity, setEntity] = useState<KeyInfo>(
    match.params.slug && endorsementKeys.length !== 0
      ? (getKeyBySlug(endorsementKeys, match.params.slug) as KeyInfo)
      : newKey,
  )
  useEffect(() => {
    const updatingKey = async () => {
      try {
        await updateEndorsementKey(entity)
        history.push('/endorsementkeys')
      } catch (error) {
        setSaving(false)
      }
    }
    if (saving) {
      updatingKey()
    }
  }, [saving])

  const handleChange = (event) => {
    const key = event.target && event.target.name
    const value = event.target && event.target.value
    if (!entity) return
    setEntity({ ...entity, [key]: value })
  }

  const handleOk = () => {
    setSaving(true)
  }

  const handleExited = () => {
    history.push('/endorsementkeys')
  }

  const updateEndorsementKey = async (endorsementKey) => {
    checkPermissions(store.getState(), UPDATE_KEYS_PERMISSION)

    dispatch(beginApiCall())
    try {
      const updatedEndorsementKey: GenericKeyResponseDto =
        await updateEndorsementKeyAsync(endorsementKey.keyId, endorsementKey)
      if (updatedEndorsementKey != null) {
        dispatch(updateEndorsementKeySuccess(updatedEndorsementKey))
        toast.success(t('key.key_saved'))
      } else {
        dispatch(endApiCall())
        toast.error(t('key.key_save_failed'))
      }
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }

  return (
    <KeyForm
      keyInfo={entity}
      onChange={handleChange}
      onSave={handleOk}
      onGoBack={handleExited}
    />
  )
}

export default EditEndorsementKeyPage
